import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { MainLayout } from "../components/templates/MainLayout";

export const PrivateRoutes = ({ roles, redirectTo = "/", children }) => {
  const usuario = useSelector((store) => store.usuario);
  if (usuario?.token && roles.includes(usuario?.rol)) {
    return <MainLayout>{children ? children : <Outlet />}</MainLayout>;
  }
  return <Navigate to={redirectTo} />;
};
